import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function Splice({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (
<div className="wrapper">
	<div className="inner-wrapper">
		<Helmet>
		    <meta charSet="utf-8" />
		    <title>Maria Chimishkyan — {ProjectModel.Splice.title}</title>
		</Helmet>

	    <Container fluid className="page-pad">
	    	<Row>
	    		<Col sm={3}>
	    			<div className="description-sticky">
	    			  <ProjectDescription projectModel={ProjectModel.Splice}/>
	    			</div>
	    		</Col>
	    		<Col sm={6}>
	    			<img src= "img/project-page/splice/splice-MariaChimishkyan-1.jpg" alt="Splice - Maria Chimishkyan 1"/>
	    		</Col>
	    	</Row>
	    </Container>
		<Container fluid className="page-pad">
			<Row>
				<Col sm={12}>
				<img src= "img/project-page/splice/splice-MariaChimishkyan-2.jpg" alt="Splice - Maria Chimishkyan 2"/>
				</Col>
			</Row>
		</Container>

	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(Splice);
